import { io } from 'socket.io-client';

import { getAuthUserFromLocalStorage } from './LocalStorage';

const socket = io(`${process.env.REACT_APP_TUTOPIYA_BASE_URL_V2}/sessions`, {
  autoConnect: false,
  transports: ['websocket'],
  auth: {
    userId: getAuthUserFromLocalStorage()?._id || '',
  },
});

export default socket;
